import axios from "axios";
import { atom, task } from "nanostores";
import { FilterData } from "./types";

interface Product {
  id: string;
  name: string;
  price: number;
  category: string;
}

export const $products = atom<Product[]>([]);

// Initialize $filter from URL on page load
const getInitialFiltersFromURL = (): string[] => {
  if (typeof window === "undefined") return [];
  const params = new URLSearchParams(window.location.search);
  const filters: string[] = [];

  params.getAll("filter").forEach(param => {
    const [type, option] = param.split(":");
    if (type && option) {
      filters.push(`${type}:${option}`);
    }
  });

  console.log("Store initialized with filters from URL:", filters);
  return filters;
};

export const $filter = atom<string[]>(getInitialFiltersFromURL());
